// extracted by mini-css-extract-plugin
export default {"ellipse":"ellipse__2bQeb","canvasWrapper":"canvasWrapper__2F3CU","canvas":"canvas__3pX9K"};